/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isRelayContext
 * 
 * @format
 */

'use strict';

/**
 * Determine if the input is a plain object that matches the `RelayContext`
 * type defined in `RelayEnvironmentTypes`.
 */
function isRelayContext(context) {
  return typeof context === 'object' && context !== null && !Array.isArray(context) && require('./isRelayEnvironment')(context.environment) && require('./isRelayVariables')(context.variables);
}

module.exports = isRelayContext;


//////////////////
// WEBPACK FOOTER
// ./~/react-relay/lib/isRelayContext.js
// module id = 171
// module chunks = 0